import React, { SetStateAction, useState } from "react";

import { useTranslation } from "react-i18next";
import {
	FrontendOrderItem,
	InstallFamiliarizeSelection,
	IQSelection,
	RepairSelection,
	ServiceContractsSelection,
} from "node-library/dist/portal";
import {
	InstrumentType,
	InstrumentCondition,
	InstrumentSource,
	OrderItemType,
} from "node-library/dist/constants";
import { BackgroundColor, SecondaryColor } from "node-library/dist/colors";
import { useSnackbar } from "../../../common-components/toast/showToastMessage";
import { PartSerialPair } from "node-library/dist/database";
import { Card } from "@mui/material";
import { CommonSwitch } from "../../../common-components/inputs";
import ItemInfoContent from "./itemInfoContent";
import { CustomIconButton } from "../../../common-components/button";
import KeyboardArrowLeftIconRounded from "@mui/icons-material/KeyboardArrowLeft";

interface Props {
	itemToUpdate: FrontendOrderItem | null;

	isInAdminView?: boolean;
	currency: string;
	addItem: (newItem: FrontendOrderItem) => void;
	updateItem: (itemToUpdate: FrontendOrderItem) => void;
	goBackToAddItemPage: () => void;
	discardItem: () => void;
	setUnsavedChanges: React.Dispatch<SetStateAction<boolean>>;
}

export default function NewItem(props: Props) {
	const { t: translation } = useTranslation();
	const { openSnackbar } = useSnackbar();

	const itemToUpdate = props.itemToUpdate;

	const [isServiceOnly, setIsServiceOnly] = useState<boolean>(
		itemToUpdate?.itemType === OrderItemType.SERVICE
	);

	const itemTypeCard: React.ReactNode = (
		<Card
			className="card-equal-padding center-align-with-gap"
			style={{ backgroundColor: SecondaryColor.SECONDARY_900, width: "100%" }}
		>
			<CommonSwitch
				id="item-type-switch"
				checked={isServiceOnly}
				setChecked={setIsServiceOnly}
			/>
			<span
				className="typography-body-01"
				style={{ color: BackgroundColor.WHITE }}
			>
				{translation("ServiceOnlyDescription")}
			</span>
		</Card>
	);

	return (
		<div
			id="new-item-body"
			className="page-content-padding"
			style={{ display: "grid", rowGap: "16px" }}
		>
			<div className="center-align-with-gap">
				<CustomIconButton
					id="back-to-order-client-details-button"
					size="small"
					onClick={() => {
						props.discardItem();
					}}
					icon={<KeyboardArrowLeftIconRounded />}
				></CustomIconButton>
				{itemTypeCard}
			</div>
			{
				<ItemInfoContent
					itemToUpdate={itemToUpdate}
					isServiceOnly={isServiceOnly}
					currency={props.currency}
					addItem={props.addItem}
					updateItem={props.updateItem}
					goBackToOrderPage={props.goBackToAddItemPage}
					discardItem={props.discardItem}
					setUnsavedChanges={props.setUnsavedChanges}
				/>
			}
		</div>
	);
}
